<template>
  <div>
    <h2>you are not authorized user for admin</h2>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({
  components: {
  },
})
export default class UnAuthorised extends Vue {
}
</script>